import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { PosthogService } from '../../services/posthog.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {
  nickname = '';
  email = '';
  password = '';
  confirmPassword = '';
  hasAcceptedLegal = false;
  error = '';
  info = '';
  isLoading = false;
  googleLoading = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private posthogService: PosthogService,
  ) {}

  onSubmit() {
    if (!this.nickname || !this.email || !this.password || !this.confirmPassword) {
      this.error = 'Please fill in all fields';
      this.posthogService.capture('register_submit_failed', {
        reason: 'missing_fields',
      });
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.error = 'Passwords do not match';
      this.posthogService.capture('register_submit_failed', {
        reason: 'passwords_mismatch',
      });
      return;
    }

    if (!this.hasAcceptedLegal) {
      this.error = 'Please accept the Privacy Policy and Terms to continue';
      return;
    }

    this.isLoading = true;
    this.error = '';
    this.posthogService.capture('register_submit_started');

    this.authService.register({
      nickname: this.nickname,
      email: this.email,
      password: this.password
    }).subscribe({
      next: (response) => {
        this.posthogService.capture('register_submit_succeeded', {
          requiresEmailConfirmation: !!response.requiresEmailConfirmation,
        });
        if (response.requiresEmailConfirmation) {
          this.router.navigate(['/login'], {
            queryParams: { emailConfirmation: 'pending' }
          });
          return;
        }

        this.info = 'Registration completed. You can now log in.';
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.posthogService.capture('register_submit_failed', {
          reason: err?.error?.error || 'request_failed',
        });
        this.error = err.error?.error || 'Registration failed';
        this.isLoading = false;
      }
    });
  }

  onGoogleRegister() {
    this.error = '';
    this.googleLoading = true;
    this.posthogService.capture('register_google_started');

    this.authService.loginWithGoogle('/sessions').subscribe({
      error: (err) => {
        this.posthogService.capture('register_google_failed', {
          reason: err?.message || 'request_failed',
        });
        this.error = err?.message || 'Google sign-up failed';
        this.googleLoading = false;
      }
    });
  }
}
